<template>
  <div class="projects">
    <div class="date" :class="{ selected: isSelected && currentSection === 'date' }" @click="onClicked('date')">
      {{ content.date }}
    </div>
    <div class="timeline" />
    <div class="data">
      <div class="title" :class="{ selected: isSelected && currentSection === 'title' }" @click="onClicked('title')">
        {{ content.title }}
      </div>
      <div
        v-if="content.info"
        class="info"
        :class="{ selected: isSelected && currentSection === 'info' }"
        @click="onClicked('info')"
        v-html="content.info"
      ></div>
      <div
        v-if="content.technos"
        class="technos"
        :class="{ selected: isSelected && currentSection === 'technos' }"
        @click="onClicked('technos')"
      >
        <span class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-technical-environment`) }}</span>
        <div class="items" v-html="content.technos"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectsComponent',
  props: {
    content: {
      type: Object,
      required: true,
    },
    onClicked: {
      type: Function,
      required: true,
    },
    currentSection: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    resumeLanguage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.subtitle {
  text-transform: uppercase;
  color: var(--color1);
  font-weight: 700;
}

.date,
.info,
.title,
.technos {
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }
}
</style>
